import { trpc } from '../../lib/trpc';
import { Text } from '@mantine/core';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import { BadgeCheck } from 'lucide-react';
import { useLocation } from 'wouter';

export const useModelDeleteDialog = ({ id }: { id: string }) => {
  const [, navigate] = useLocation();
  const { mutateAsync: deleteModelAsync } = trpc.models.delete.useMutation();
  const utils = trpc.useUtils();

  const initiateModelDelete = () =>
    modals.openConfirmModal({
      children: <Text size="sm">You are about to delete a content type.</Text>,
      confirmProps: { color: 'red' },
      labels: { cancel: 'Cancel', confirm: 'Confirm' },
      onConfirm: async () => {
        await deleteModelAsync(id);
        notifications.show({
          message: (
            <>
              <BadgeCheck stroke="var(--color-lime-400)" /> Content type deleted
            </>
          ),
        });
        utils.models.list.invalidate();
        navigate('/', { replace: true });
      },
      title: 'Please confirm your action',
    });
  return { initiateModelDelete };
};
